
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1883|3397|5901|9305)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
